import { useEffect, useState } from 'react'
import { getAmoNudge } from '@services/investors.service';
import { isValidResponseEntity } from '@helpers/utils';
import { isTradingAllowed } from '@services/trading.service';
import useInvestmentStore from '@store/useInvestmentStore';
import { isUnlistedOpportunityType } from '@helpers/opportunity';

const useOpportunitiesInvestment = (opportunityType, isClosed = false, isAuthorized = true) => {
    const isUnlisted = isUnlistedOpportunityType(opportunityType);
    const [amoDetails, setAmoDetails] = useState({
        promisedAmoOrderCount: null,
        pendingAmoOrderCount: null,
        pendingOrderCount: null
    });
    const { setInvestmentError } = useInvestmentStore();
    const [tradingTimeDetails, setTradingTimeDetails] = useState({
        isTradingAllowed: false,
        isHoliday: false,
        isAmoTradingAllowed: false,
        isRfqAllowed: false,
        isPostMarketHours: false,
        isPreMarketHours: false,
        marketOpenTime: null,
    });
    const [loading, setLoading] = useState(null);
    const getAmoDetails = async (investorId) => {
        if(!isAuthorized) return;
        const response = await getAmoNudge(investorId);
        if (isValidResponseEntity(response)) {
            setAmoDetails({
                promisedAmoOrderCount: response?.entity?.promisedAmoOrderCount,
                pendingAmoOrderCount: response?.entity?.pendingAmoOrderCount,
                pendingOrderCount: response?.entity?.pendingOrderCount
            })
        }
    }
    const getIsTradingAllowed = async (type) => {
        if(!isAuthorized) return;
        setLoading(true);
        const response = await isTradingAllowed(type, isUnlisted);
        if (isValidResponseEntity(response)) {
            setTradingTimeDetails({
                isTradingAllowed: response?.entity?.isTradingAllowed,
                isHoliday: response?.entity?.isHoliday,
                isAmoTradingAllowed: response?.entity?.isAmoTradingAllowed,
                isRfqAllowed: response?.entity?.isRfqAllowed,
                isPostMarketHours: response?.entity?.isPostMarketHours,
                isPreMarketHours: response?.entity?.isPreMarketHours
            })
        } else {
            if (type) setInvestmentError(response?.message[0])
        }
        setLoading(false);
    }

    const setMarketOpenTime = (time) => {
        setTradingTimeDetails((prev) => ({
            ...prev,
            marketOpenTime: time
        }));
    }

    useEffect(() => {
        if (isAuthorized) {
            // Fetch trading and AMO details only if the user is authorized
            getAmoDetails();
            if (!isClosed) getIsTradingAllowed();
        }
    }, [isAuthorized]);

    // Default to 0 if user is not authorized or details are unavailable
    return {
        loading,
        promisedAmoOrderCount: isAuthorized ? amoDetails.promisedAmoOrderCount : 0,
        pendingAmoOrderCount: isAuthorized ? amoDetails.pendingAmoOrderCount : 0,
        pendingOrderCount: isAuthorized ? amoDetails.pendingOrderCount : 0,
        isAmoTradingAllowed: tradingTimeDetails.isAmoTradingAllowed,
        isPostMarketHours: tradingTimeDetails.isPostMarketHours,
        isPreMarketHours: tradingTimeDetails.isPreMarketHours,
        isTradingAllowed: tradingTimeDetails.isTradingAllowed,
        isHoliday: tradingTimeDetails.isHoliday,
        isRfqAllowed: tradingTimeDetails.isRfqAllowed,
        marketOpenTime: tradingTimeDetails.marketOpenTime,
        setAmoNudge: getAmoDetails,
        setIsTradingAllowed: getIsTradingAllowed,
        setMarketOpenTime: setMarketOpenTime,
        setInvestmentError,
    };
}

export default useOpportunitiesInvestment;